<template>
    <div class="cgs-worksheet-customPageContent">
        <custom-page-content v-if="Object.keys(gridItemConfig).length > 0" :gridItemConfig="gridItemConfig" :staticGrid="true" :fullSceenAbled="true"></custom-page-content>
    </div>
</template>

<script>
import { NavBar, Tab, Tabs, PullRefresh } from 'vant';
import customPageContent from "./content.vue";
import { getWorksheetInfo } from "@/api/application"
export default {
    components: {
        vanNavBar: NavBar,
        vanTab: Tab,
        vanTabs: Tabs,
        customPageContent
    },
    props: {worksheetDetail: Object},
    data(){
        return {
            // worksheetDetail: {}
        }
    },
    mounted(){
        this.init()
    },
    computed:{
        worksheetId:{
            get(){
                return this.$props.worksheetDetail.id
            },
            set(){}
        },
        gridItemConfig: {
            get(){
                let config = {};
                if('config' in this.$props.worksheetDetail ){
                    config = this.$props.worksheetDetail.config === '' ? {} : JSON.parse(this.$props.worksheetDetail.config)
                }
                return config
            },
            set(){}
        }
    },
    watch:{
        worksheetId(){
            this.init()
        }
    },
    methods:{
        async init(){
            this.wholeLoading = true
            try{
                // let result = await getWorksheetInfo(this.worksheetId)
                // this.worksheetDetail = result.data
                // if('config' in this.worksheetDetail ){
                //     this.worksheetDetail.config = this.worksheetDetail.config === '' ? [] : JSON.parse(this.worksheetDetail.config)
                // }
            } catch(e){
                console.error(e)
            } finally{
                // this.wholeLoading = false
            }
        },
        goBack(){
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>
.cgs-worksheet-customPageContent{
    height: 100%;
}
</style>